import { AccountStatusService } from '../../../services/account-status/account-status.service';
import { ResponseModal2Component } from './../../../components/response-modal2/response-modal2.component';
import { Component, OnInit, Injectable, Inject } from '@angular/core';
import { NgbActiveModal, NgbDatepickerI18n, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchInvoicesService } from '../../../services/search-invoices.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { WebStorageService, LOCAL_STORAGE } from 'angular-webstorage-service';
import { TranslateService } from '@ngx-translate/core';
import { ToasterService } from 'angular5-toaster';

@Injectable()
export class I18n {
  lang; language;
  constructor(
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
  ) {
    // console.log(this.storage.get('LOCAL_STORAGE'));
    this.lang = this.storage.get('LOCAL_STORAGE');

    if (this.lang === 'es') {
      this.language = this.lang;
    } else {
      this.language = 'en';
    }
  }
}


@Component({
  selector: 'app-download-files',
  templateUrl: './download-files.component.html',
  styleUrls: ['./download-files.component.scss'],
  providers: [I18n, AccountStatusService]
})
export class DownloadFilesComponent implements OnInit {

  xml: boolean = false;
  pdf: boolean = false;
  emails: string = "";
  passedData: Array<any>;
  tipoConsultaPassed: any;
  form: FormGroup;
  invalidEmail: boolean = false;
  busyBusqueda: boolean = false;
  emailEnviado: string = "";

  tituloEnvioCorreo;
  toastEmptyInvoice;
  errorDescargaFactura;

  busyDescarga: boolean = false;

  constructor(
    private accountStatus: AccountStatusService,
    private translate: TranslateService,
    public activeModal: NgbActiveModal,
    public modalService: NgbModal,
    private toasterService: ToasterService,
    private facturaRemService: SearchInvoicesService, ) {
      this.translate.get('texto.informacionEnviada').subscribe(
        text => {
          this.tituloEnvioCorreo = text;
        });

        this.translate.get('texto.emptyInvoice').subscribe(
          text => {
            this.toastEmptyInvoice = text;
        });

        this.translate.get('texto.errorDescargaFactura').subscribe(
          text => {
            this.errorDescargaFactura = text;
        });

     }

  ngOnInit() {
    this.form = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
    })
  }

  descargaMultiple2() {
    // console.log(this.passedData);
    if (this.passedData.length != 0) {
      this.busyDescarga = true;
      this.accountStatus.descargaMasivaArchivos(this.passedData, this.xml, this.pdf, this.tipoConsultaPassed).subscribe(
        res => {
          // this.visualizarArchivo(res, 'application/zip');
          var file = new Blob([res], { type: 'application/zip' });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL, '_blank');
          this.closeModal();
          this.busyDescarga = false;
        },
        error => {
          this.busyDescarga = false;
          if (error.status === 501) {
            this.toasterService.pop('error', this.errorDescargaFactura);
          } 
          else if (error.status === 500) {
            this.toasterService.pop('error', this.errorDescargaFactura);
          }
          else {
            console.log(error);
          }
        }
      );
      
    } else {
      this.toasterService.pop('error', this.toastEmptyInvoice);
    }
  }

  visualizarArchivo(data: any, tipo: string) {
    var file = new Blob([data], { type: tipo });
    var fileURL = URL.createObjectURL(file);
    window.open(fileURL, "EPrescription");

    var win = window.open();
    win.document.write('<iframe src="' + fileURL  + '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>');
}

  closeModal() {
    this.activeModal.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/account-status/download-files/download-files.component.ts